import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import UserMenu from '../UserMenu';

function UserInfo({data, image}) {    
    if(!data)
        return null;
    const { username = '', email = '' } = data;
        return (
            <div className="user-info-container" style={{display: 'flex', alignItems: 'center', position: 'relative', height: '100%'}}>
                <div className="flex-container-align-vertically" style={{width:'30px', height: '30px', borderRadius:'50%', justifyContent: 'center', margin: '0 10px'}}>
                {
                    image !== '' ?
                    <img src={image} style={{width: '100%', borderRadius:'50%'}} />
                    :
                    <UserOutlined style={{fontSize: '24px', margin: 0}} />
                }
                </div>
                <div className="user-info-wrapper" style={{ display: 'flex', flexDirection:'column'}}>
                    <span style={{color:'#595959'}} className="margin-0 label em">{username}</span>
                    <span style={{color:'#595959'}} className="margin-0 small-text">{email}</span>
                </div>
                <UserMenu/>
            </div>
        )
    }

export default UserInfo
